import './StatisticsPage.scss';
import { useAppConfig } from '../../../Contexts/AppConfigContext';
import { useTranslation } from 'react-i18next';
import { BarChartOutlined, LineChartOutlined, PieChartOutlined, RiseOutlined } from '@ant-design/icons';

const StatisticsPage = (): JSX.Element => {
    const { t } = useTranslation();
    const appConfig = useAppConfig();

    return (
        <div className="statistics-page">
            {appConfig?.config?.clientData?.powerBiUrl ? (
                <div className='statistics-container'>
                    <iframe className='statistics-iframe' src={appConfig.config.clientData.powerBiUrl} />
                </div>
            ) : (
                <div className="stats-placeholder">
                    <div className="stats-placeholder__icon-row">
                        <BarChartOutlined />
                        <RiseOutlined />
                        <LineChartOutlined />
                        <PieChartOutlined />
                    </div>
                    <h2 className="stats-placeholder__title">{t('pages.statistics.placeholder.title')}</h2>
                    <p className="stats-placeholder__desc">{t('pages.statistics.placeholder.description')}</p>
                    <div className="stats-placeholder__features">
                        <div className="stats-placeholder__feature">
                            <BarChartOutlined />
                            <span>{t('pages.statistics.placeholder.feature-1')}</span>
                        </div>
                        <div className="stats-placeholder__feature">
                            <RiseOutlined />
                            <span>{t('pages.statistics.placeholder.feature-2')}</span>
                        </div>
                        <div className="stats-placeholder__feature">
                            <PieChartOutlined />
                            <span>{t('pages.statistics.placeholder.feature-3')}</span>
                        </div>
                        <div className="stats-placeholder__feature">
                            <LineChartOutlined />
                            <span>{t('pages.statistics.placeholder.feature-4')}</span>
                        </div>
                    </div>
                    <p className="stats-placeholder__note">{t('pages.statistics.placeholder.note')}</p>
                </div>
            )}
        </div>
    );
}

export default StatisticsPage;